import { render, staticRenderFns } from "./ReportTabIntelligence.vue?vue&type=template&id=6c9641b6&scoped=true"
import script from "./ReportTabIntelligence.vue?vue&type=script&lang=js"
export * from "./ReportTabIntelligence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9641b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c9641b6')) {
      api.createRecord('6c9641b6', component.options)
    } else {
      api.reload('6c9641b6', component.options)
    }
    module.hot.accept("./ReportTabIntelligence.vue?vue&type=template&id=6c9641b6&scoped=true", function () {
      api.rerender('6c9641b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Report/Tab/ReportTabIntelligence.vue"
export default component.exports